module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "d12e313"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Rola_1595552685_epub_c7_r1#d12e137",
      "id": "d12e314"
    }
  }, [_c('i', [_vm._v("chapter 2")]), _c('br'), _c('br'), _vm._v(" TENNESSEE RIVER BOYS")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0018_003",
      "id": "d12e320",
      "src": "images/9781595552686_ePDFnf_0018_003.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e321"
    }
  }, [_c('span', {
    staticClass: "dcap",
    attrs: {
      "id": "d12e322"
    }
  }, [_c('i', [_vm._v("D")])]), _vm._v("iamond Rio’s professional life in 2005 was a tumultuous roller coaster, appropriate since the band could trace its beginnings to an amusement park. Opryland opened in Nashville in May 1972 with the usual theme park array of thrill rides, midway games, souvenirs, and cotton candy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e326"
    }
  }, [_vm._v("The tourist attraction’s parent company, the National Life and Accident Insurance Company, also owned the Grand Ole Opry and made a point of emphasizing that musical connection in branding the venture. The Opry radio show first aired on WSM-AM in November 1925. Its rural-themed variety format soon established the Opry as the leader among what were then known as “barn dance” programs. The WSM signal covered much of eastern America, and the Saturday Opry shows went national when NBC’s radio network added the program in 1939. Because of its association with that radio program, Opryland was built with a heavier emphasis on music than most theme parks.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e328"
    }
  }, [_vm._v("The Grand Ole Opry House opened on the park’s grounds in March 1974, providing a modern, suburban home for the Opry after thirty-one years at the downtown Ryman Auditorium. "), _c('i', [_vm._v("The Porter Wagoner Show ")]), _vm._v("and "), _c('i', [_vm._v("Hee Haw ")]), _vm._v("began taping their syndicated episodes in the Opryland production studios, in the same building as the Opry House. The park’s Roy Acuff Theater took its name from a country legend. And one of Opryland’s most popular rides, the Wabash Cannonball, drew its name from one of Roy’s best-known hits. Roy, in fact, moved to a home on the Opryland property in 1983, the same year that the park’s new ownership, the Gaylord Entertainment Company, inaugurated The Nashville Network (TNN)—a cable station that put a country stamp on such established TV formats as talk shows, variety programs, and talent contests.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e336"
    }
  }, [_vm._v("During tourist season Opryland scheduled a heavy stream of live performances that aimed to attract every potential age group. "), _c('i', [_vm._v("I Hear America Singing ")]), _vm._v("examined folk and traditional pop from various regions across the country; "), _c('i', [_vm._v("Rocking Around the Clock ")]), _vm._v("was a standard ’50s revue; and "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("told the history of Nashville’s best-known musical genre with a cast of singers imitating the likes of Hank Williams, Jim Reeves, and Patsy Cline.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e347"
    }
  }, [_vm._v("Its Music City location guaranteed the park could tap into a rich vein of talent, and numerous songwriters and musicians hooked up with Opryland jobs while trying to immerse themselves in the Middle Tennessee music community.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e349"
    }
  }, [_c('b', [_vm._v("TENNESSEE RIVER BOYS: "), _c('br'), _vm._v(" CONNECTING THE PLAYERS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e354"
    }
  }, [_vm._v("It was in that atmosphere that a couple of park employees—Matt Davenport and Danny Gregg—put together a group for a one-time TV performance in 1982 that would promote Opryland on a local station. They billed themselves as the Grizzly River Boys, calling attention to a new log flume–style ride, the Grizzly River Rampage, and they impressed both the television station and their bosses at the park. The first appearance turned into a second, and Opryland soon gave them their own show built around a trio of singers—Matt, Danny, and Ty Herndon—who swapped lead voices, told jokes, and balanced old-school country concert shtick with a contemporary sound.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e356"
    }
  }, [_vm._v("None of the players who would eventually make their mark in Diamond Rio were affiliated with the Grizzly River Boys at its start. And no one knew what a significant breeding ground of talent the group would become. In addition, no one was particularly fond of the name. In short order the Grizzly River Boys became the Tennessee River Boys, paying a nod to the park’s setting along the Cumberland. Even the new name wasn’t quite appropriate. Bluegrass pioneers such as Bill Monroe and Ralph Stanley had identified their bands with geographic imagery—the Blue Grass Boys and the Clinch Mountain Boys—so the Tennessee River Boys’ moniker often led park visitors to expect an old-timey or rustic sound instead of the rock- and pop-influenced brand of country the group represented.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e358"
    }
  }, [_vm._v("The name Tennessee River Boys had, in fact, been used in the past by two different acts. A bluegrass duo recorded for Mercury during the early 1950s under the banner Paul & Roy & the Tennessee River Boys, and an R & B group, Rambling Rufus Shoffner & His Tennessee River Boys, cut some tracks that same decade.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e361"
    }
  }, [_vm._v("Despite the anachronistic name, the Tennessee River Boys quickly developed a following—not just among Opryland season-ticket holders, but also among some of the musicians who played with established stars at the Opry. That included Dana Williams, a bass player who worked with Jimmy C. Newman. His high school music teacher, Al DeLeonibus, played piano for the River Boys, and whenever Jimmy C did an Opry matinee, Dana would take in at least one of the River Boys’ performances at the Gaslight Theater.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e363"
    }
  }, [_vm._v("“I’d go over and see the Tennessee River Boys play during the day, and I’d see my buddy Al DeLeonibus playin’ with them,” Dana recalls. “Then I’d come back and do an Opry spot and go back and listen there. They played two hundred sets a day or somethin’.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e365"
    }
  }, [_vm._v("The Oak Ridge Boys were one of only a handful of groups having success in country music at the time, and all four Oaks got opportunities to sing lead at their shows. The River Boys took the same approach.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e367"
    }
  }, [_vm._v("“Danny Gregg, he was a showman and a half,” Dan Truman notes. “He was so good off the top of his head. He was funny and had so much good energy. Matt was just a rock. He could sing lead and harmonies, and he was a great musician.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e369"
    }
  }, [_vm._v("Notwithstanding their group approach to the vocals, Ty Herndon was the main attraction, and it didn’t take long for the Opry bosses to recognize it. When Ed McMahon started the syndicated TV competition "), _c('i', [_vm._v("Star Search ")]), _vm._v("in 1983, Opryland suggested Ty as a first-year contestant and he went all the way to the finals, bested only by Oklahoma-bred pop singer Sam Harris. Ty won a significant payoff in the process and decided it was time to pursue life as a solo performer. It took him nearly a decade, but he eventually grabbed the brass ring with a series of country hits, beginning with “What Mattered Most” in 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e374"
    }
  }, [_vm._v("In the meantime Al DeLeonibus told Dana the Tennessee River Boys were looking for a replacement: “Yeah, Ty finally quit, man. The chicks are goin’ nuts over this guy.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e376"
    }
  }, [_vm._v("That set up a short-lived revolving door in the River Boys’ third vocal spot. Anthony Crawford—who would go on to work as a backup vocalist on albums by Rosanne Cash, Dwight Yoakam, and Steve Winwood—took over Ty’s position for a while. He left for a tour with Neil Young and was replaced by another park employee, Virgil True, for much of the ’84 season.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e378"
    }
  }, [_c('i', [_vm._v("Marty Roe")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e381"
    }
  }, [_vm._v("Virgil likewise got a job with a touring act, and Danny Gregg and Matt Davenport turned to Marty Roe, who was doing Larry Gatlin imitations in Opryland’s "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("show, to finish out the year. The band had become acquainted with him when Marty performed on a TNN show Danny had hosted, and they knew his back-of-the-throat twang would provide a diversion from the pop-inflected vocals they were already offering as they passed the lead slot around from song to song.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e386"
    }
  }, [_vm._v("“It was a good-payin’ gig—paid better than what I was makin’,” Marty recalls. “They had some road dates they wanted me to do, and they were talkin’—Alabama had hit in 1980, and this was ’84—and they had this idea to go and do something like that, get a record deal. We "), _c('i', [_vm._v("were ")]), _vm._v("in Nashville.”")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e391"
    }
  }, [_c('i', [_vm._v("Dan Truman")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e395"
    }
  }, [_vm._v("At the close of the ’84 season, Gaylord head honcho Ed Gaylord brought a group of Opryland performers to the Oklahoma State Fair to showcase his company in his hometown with a ten- or twelve-day run. "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("rotated two casts at the park—a red cast and a blue cast—with the former unofficially considered the lead crew. Performers from the red cast formed the backbone of the band at the Oklahoma fair, and Opryland officials recruited musicians from other park shows to fill out the roster. Marty, who still remembered much of the "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("script and music, was a natural addition, as was Dan Truman, the piano player from "), _c('i', [_vm._v("Country Music USA")]), _vm._v("’s blue cast.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e406"
    }
  }, [_vm._v("Dan had been extremely active just months before, one of three keyboardists who worked a TNN show at $220 a pop in addition to his regular role in the park’s productions. But the TV show had been canceled, Opryland’s seasonal live shows were closing for the winter, and his $1,000-a-week paychecks had suddenly dried up. Dan earned a paltry $265 for the entire month of November. So the Oklahoma gig was quite welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e408"
    }
  }, [_vm._v("“It was cool,” Dan says. “I had ten more days of work, and I said I’d do it. Well, Marty was one of the singers in that show. They used their best singers to showcase Opryland in Oklahoma City, and that’s where we got to know each other.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e410"
    }
  }, [_vm._v("After years of playing the road with show bands and pushing himself to practice daily, Dan easily impressed Marty with his skills. Little did Dan know he was laying the groundwork for his next job.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "1",
      "id": "d12e412",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e413"
    }
  }, [_vm._v("Before the 1985 season began at Opryland, Al DeLeonibus—convinced that Ty’s departure meant the Tennessee River Boys had no commercial future—quit the band. Their drummer, Ed Mummert, dropped out as well. Marty suggested Dan and the Oklahoma-fair drummer, Jimmy “J. J.” Whiteside, and the River Boys were again completely staffed. For a week or two anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e415"
    }
  }, [_vm._v("Larry Beard, the group’s guitar player, had hoped to join the vocal ranks in the band. When Marty filled Ty’s slot, Larry felt he had hit the proverbial glass ceiling and decided to move along. He clearly had some abilities—he would later play on albums by the likes of BlackHawk, Craig Morgan, and Billy Joe Royal—and his departure left a major gap in the Tennessee River Boys. In need of a replacement, the River Boys held an audition in March 1985 at the Musicians Union on Music Row, across the alley from the Sound Stage, a recording studio that had recently hosted sessions that yielded hits for George Strait, Conway Twitty, and the Statler Brothers.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e417"
    }
  }, [_c('i', [_vm._v("Jimmy Olander")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e420"
    }
  }, [_vm._v("In that professional setting the band hoped it could land the kind of guitarist who would help build the commercial flair they were after. Or, at the very least, pick up the slack after Larry’s departure.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e422"
    }
  }, [_vm._v("Jimmy Olander had worked at Opryland before, so he knew the drill. He had done his time in "), _c('i', [_vm._v("Country Music USA")]), _vm._v(", then left to go on the road with a bar band. He graduated to become a sideman for Mel McDaniel, who was getting regular airplay at the time with “Louisiana Saturday Night,” “Big Ole Brew,” and the aptly titled “I Wish I Was in Nashville.” ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e427"
    }
  }, [_vm._v("Jimmy had quit Mel’s band to try and stay closer to home in Music City. He had a wife to support and an idea that he could break into the ranks of Nashville’s session guitarists. He was playing somewhat steadily on Nashville’s fabled Printers Alley. But good musicians are plentiful in Music City, so the paycheck at those clubs was dismal. The studio work hadn’t come as quickly as he had anticipated, and he needed a job. Jimmy wasn’t particularly enthralled with the prospect of returning to Opryland. But "), _c('i', [_vm._v("that ")]), _vm._v("gig beat "), _c('i', [_vm._v("no ")]), _vm._v("gig. He could bear it for one season.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e436"
    }
  }, [_vm._v("“I was gonna be there six months—that’s it,” Jimmy says. “I gave ’em a false promise: ‘Oh yeah, I’m a candidate. I need a job.’ I’d already been on the road in a tour bus, and these guys were in a band pulling a trailer and they didn’t have much work. They were from Opryland, and oh, I judged this [as], "), _c('i', [_vm._v("This is way, way below me.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e441"
    }
  }, [_vm._v("Jimmy’s disdain was not out of the ordinary among those with aspirations in the commercial recording business. Music Row’s bread and butter came from creating new material and building stars. Shows like"), _c('i', [_vm._v(" Country Music USA ")]), _vm._v("were centered on covering the hits and mimicking established stars.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e446"
    }
  }, [_vm._v("“That’s not the real world,” Jimmy explains. “That’s not goin’ out and findin’ gigs and makin’ a livin’. You actually do punch a time clock, and you go put your uniform on and perform a show, and there’s a script of bits that have been written for you. It’s not the real world. That’s not music!”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0025_003",
      "id": "d12e448",
      "src": "images/9781595552686_ePDFnf_0025_003.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e449"
    }
  }, [_c('b', [_c('i', [_vm._v("Left to right")]), _vm._v(": Jimmy Olander, Marty Roe, Mel Deal, Matt Davenport, Danny Gregg, J. J. Whiteside, Dan Truman. “Jimmy had a beard when he auditioned and had to shave it because Opryland didn’t allow beards.” —Marty")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e454"
    }
  }, [_vm._v("Jimmy made a point during the audition to not share his hostile philosophy about Opryland with his prospective bandmates, who were instantly intrigued by his sound. Jimmy played a newly developed guitar, a Telecaster with a double-bender, an attachment that allowed him to raise the tone of one or two notes at a time. The guitar was barely heard of among professionals, let alone in amusement-park bands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e456"
    }
  }, [_vm._v("“I didn’t even know what he was doin’ at the time,” Marty says, laughing. “It was the wildest thing, a really different sound. And it was really good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e458"
    }
  }, [_vm._v("Which made the Tennessee River Boys’ decision fairly easy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e460"
    }
  }, [_vm._v("“Three guys showed up; Jimmy was the best,” Dan says. “It’s that simple.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e462"
    }
  }, [_vm._v("The River Boys and their readjusted lineup—Danny Gregg, Marty Roe, and bass-playing Matt Davenport on vocals; Dan Truman playing piano; Jimmy Olander on guitar; Mel Deal on steel guitar; and J. J. Whiteside pounding the drums—tried to make some inroads at record labels that summer. They soon discovered that Jimmy’s contempt for Opryland was fairly commonplace on Music Row.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e464"
    }
  }, [_c('b', [_vm._v("OPRYLAND: HELP OR HINDRANCE?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e468"
    }
  }, [_vm._v("The park had launched some talents to be sure—former Opryland employee Deborah Allen got a Grammy nomination for her heartbreaking 1984 hit “Baby I Lied”; "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("alum Dean Rutherford, working under the professional name Dean Dillon, had already written George Jones’s “Tennessee Whiskey,” Hank Williams Jr.’s “Leave Them Boys Alone,” and George Strait’s “Unwound”; and bass player Don Cook had penned John Conlee’s “Lady Lay Down” and the Oak Ridge Boys’ “Cryin’ Again.” But the park still had that second-rate reputation that was tough to overcome.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e473"
    }
  }, [_vm._v("“When you were at Opryland, there was a stigma about you,” Jimmy says. “Cheesy, showbiz, "), _c('i', [_vm._v("Up with America")]), _vm._v("—whatever that was—it was that thing. It’s probably why when I joined the band, I had that [attitude] as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e478"
    }
  }, [_vm._v("In his planned six-month tenure, however, Jimmy saw a side of the Boys he hadn’t expected. There was talent in the band, along with a drive to become something bigger, not just a copy band that counted on an Opryland paycheck. They attracted the attention of Len “Snuffy” Miller—who’d played drums for Bill Anderson and produced the 1975 Kenny Starr hit “The Blind Man in the Bleachers”—and he took them in the studio, crossing his fingers he could get them a deal on Music Row.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e480"
    }
  }, [_vm._v("They recorded three songs, with Matt, Danny, and Marty each taking the lead vocal on one.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e482"
    }
  }, [_vm._v("“Variety is what kept us our gig out at Opryland, ’cause you’re playing [for ages] two to ninety-two,” Marty says. “We felt like that was a strength, that we could play all kinds of different styles, so we recorded that way.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e484"
    }
  }, [_vm._v("Snuffy shopped them around to Nashville’s labels during 1985 but found no takers. Warner Bros. chief Jim Ed Norman, however, must have heard something he liked. He took the time to counsel the group.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e486"
    }
  }, [_vm._v("“[Jim Ed] asked, ‘What are you guys? Are you a country band?’” Marty recalls. “‘Well, we can do whatever you want.’ That was our attitude. Jim Ed said, ‘No, you gotta make a decision [about] who you are, what you wanna be. Pick one.’ That was good advice. We didn’t really wanna hear it at the time, but it was good advice, so I credit him for helpin’ us to understand that these record labels, they ain’t gonna figure it out for you. You gotta figure it out yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e488"
    }
  }, [_c('b', [_vm._v("BREAKING LOOSE: ON THE ROAD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e491"
    }
  }, [_vm._v("One thing the Tennessee River Boys figured out for sure: they needed to leave Opryland at the end of the 1985 season.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e493"
    }
  }, [_vm._v("“We felt Opryland was great,” Marty says. “We were able to make a living playing music, we were in Music City U.S.A., we were close to the action and [thought] we should be able to get discovered. Music Row completely discredited what we did out there because it was a bunch of kids and ‘They’re not real musicians. They’re not real artists.’ So we quit. We quit the park.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e495"
    }
  }, [_vm._v("“Nobody would take it seriously,” Dan adds. “We’d kinda had that counseled to us: get out of there, and get in the real world. And then it took six years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e498"
    }
  }, [_vm._v("The band’s manager, Steve Thurman, worked at the Top Billing booking agency, which procured concerts for the likes of Ronnie McDowell, Mel McDaniel, and comedian Jerry Clower, who “Snuffy” Miller produced. Tandy Rice, who owned Top Billing, got the River Boys work on the road when he could, but they didn’t have hits or much of a name outside the Opryland grounds. At least they had equipment. Letting the other artists use it made them a little more attractive to the headliner and to concert promoters, who were always looking for ways to cut costs.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e500"
    }
  }, [_vm._v("“We were making investments in sound systems so that we could get a gig,” Marty says. “So that was really a big reason why we were [working much at all]—the fact that they had an opening act with a sound system. That’s how they looked at it. We looked at it that, oh, we’ve got a gig.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e502"
    }
  }, [_vm._v("The River Boys also supplemented their calendar by signing up with New York’s Columbia Artists Management to do subscription dates. The agency acted as a clearinghouse for community concert series in smaller towns that had little access to top-level entertainment. Residents bought season tickets that entitled them to attend a range of performances by different acts, similar to the subscriptions that fine-arts organizations sell to their members in larger cities.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e504"
    }
  }, [_vm._v("Productions such as the Guy Lombardo Big Band, the Blind Boys of Alabama, or "), _c('i', [_vm._v("Irving Berlin Century")]), _vm._v("—featuring traditional pop songs written by one of America’s best-known composers—exposed subscribers to swing music, gospel, and show tunes. The Tennessee River Boys added a youthful component to the series and contributed country to the stylistic blend.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e509"
    }
  }, [_vm._v("There was nothing glamorous about the locations. They played high school auditoriums or small outdoor parks in places like Waukegan, Illinois; Wellsboro, Pennsylvania; and Reidsville, North Carolina. Their tour schedules were concentrated—four or six weeks long at the most—but some of the guys counted a $4,200 take from those performances as half their income for the year. Most of the time they worked no more than four shows in a month and tried to convince themselves they were doing the right thing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e511"
    }
  }, [_vm._v("“It had to be a big eye-opener for them, actually going out and doing stuff on the road,” says Gene Johnson, a touring veteran who would meet—and join—the River Boys two years later. “You’re not in that controlled environment anymore. You’re goin’ out and you’re playin’, it’s costing you money now to get to shows, you don’t have a guaranteed audience sittin’ there. You actually have to draw them in or be playing with somebody that does. That scares away a lot of pickers right there. They changed a lot of pickers right in that time period. It’s not quite as easy as it looks.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e513"
    }
  }, [_c('b', [_vm._v("RESTLESS HEART’S ENCOURAGING SUCCESS")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e516"
    }
  }, [_vm._v("The success of another group, Restless Heart, gave the River Boys at least some hope that they could make the transition from Opryland to viable band. Restless Heart made its initial entry on the "), _c('i', [_vm._v("Billboard ")]), _vm._v("country chart during the first month of 1985, and by the end of the year, the band had landed two singles in the Top 10 and another in the Top 25. Two of the band’s members—guitarist Greg Jennings and bass player Paul Gregg, the brother of the River Boys’ Danny Gregg—were Opryland graduates.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e521"
    }
  }, [_vm._v("Their producer, Tim DuBois, further cemented Restless Heart’s connection to the park’s corporate structure. His wife, Cee Cee, had been a background singer on one of the TNN shows with Paul Gregg and the River Boys’ Matt Davenport. It was a small consolation, however. Restless Heart publicly glossed over its ties to the theme park, and only a couple of its members had worked at Opryland—not the entire band.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e523"
    }
  }, [_c('i', [_c('b', [_vm._v("STAR SEARCH")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e527"
    }
  }, [_vm._v("The record labels weren’t calling, but Hollywood did. "), _c('i', [_vm._v("Star Search")]), _vm._v(", the same show that had provided a platform for former member Ty Herndon, gave the Tennessee River Boys a slot in one of its episodes. The Boys had seen some of the bands that had competed in previous installments, and they were convinced they could place high with their performances. They were told to bring at least four stage outfits apiece, and the production crew seemed to think they’d move up the ladder fairly easily.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e533"
    }
  }, [_vm._v("They didn’t. Performing “Take Me to the River,” they lost in the first round, adding to the sense of rejection they were feeling in other quarters.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e535"
    }
  }, [_vm._v("“That was a really tough night,” Marty says. “I remember sittin’ in the hotel room on the bed, with the whole band, beatin’ my head up against the wall—‘I’m quittin’ this business, it’s stupid!’ It was crushing.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e537"
    }
  }, [_c('b', [_vm._v("FAMILY LIFE")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e540"
    }
  }, [_vm._v("Most of the group was married. Most were also purposely not having any babies. They couldn’t afford them and couldn’t afford the distraction from their career, unfruitful though it was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e542"
    }
  }, [_vm._v("Dan—whose wife, Wendee, worked on a show on Opryland’s "), _c('i', [_vm._v("General Jackson ")]), _vm._v("showboat—was one of the few River Boys who looked after a child. Other than teaching some piano lessons and playing the scattered River Boys shows, Dan had no work, so he started most days by putting his son, Ben—who was eighteen months old as 1986 opened—in a wind-up swing set to keep the boy occupied while Dad practiced. After lunch Dan would take his son for a walk down Graycroft Avenue in Madison or run errands in the family’s lone car, then tuck Ben in for a nap while he practiced again in the afternoon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e547"
    }
  }, [_vm._v("“I remember bein’ in the car and I didn’t want him to be asleep,” Dan says. “I needed him to sleep at home so I could practice, so I’d start talkin’ real loud. This is when he was one or two, so he might not understand what I was saying, but I’d be talkin’ real loud and I remember him lookin’ at me like, "), _c('i', [_vm._v("What are you doin’? I’m tryin’ to go to sleep! ")]), _vm._v("And I’d keep him awake all the way home so he’d go to sleep when I got home and I could practice.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0031_001",
      "id": "d12e552",
      "src": "images/9781595552686_ePDFnf_0031_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e553"
    }
  }, [_c('b', [_vm._v("Ben Truman–13 months old")])]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e556"
    }
  }, [_c('b', [_vm._v("DRUMMER LOST AND FOUND")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e559"
    }
  }, [_vm._v("Without Opryland supplying a regular check, the mix of nonpaying practices, relentless bills, and dependent families started to take its toll on the River Boys roster. The first casualty was J. J., the drummer.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e561"
    }
  }, [_vm._v("“He got all sideways,” Marty notes. “I don’t really know why, but he was disenchanted with what we were doin’. There wasn’t much money involved in it, so he quit.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e564"
    }
  }, [_vm._v("They rounded up a few prospects and held auditions at Danny’s home in a Donelson duplex. None of them quite fit the bill. But another Opryland drummer, Suzanne Elmer, thought she might have a solution for them. In addition to playing at the theme park, she also held down a night job in Jim Vest’s band at Faron Young’s Country Junction, a club on Printers Alley. The musicians at the Alley’s watering holes kept tabs on the talent at the other venues, too, and she knew of a drummer named Brian Prout, who worked with a band called Heartbreak Mountain at the Western Room.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0032_002",
      "id": "d12e566",
      "src": "images/9781595552686_ePDFnf_0032_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e567"
    }
  }, [_c('b', [_c('i', [_vm._v("Left to right")]), _vm._v(": Jimmy Olander, Brian Prout, Marty Roe, Matt Davenport, Danny Gregg, Dan Truman")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e572"
    }
  }, [_vm._v("The River Boys set up a second day of auditions with several drummers, but thanks to Suzanne’s recommendation, they were most interested in Brian. He had just turned thirty and felt he needed to find another outlet if he ever hoped to escape the club circuit. The Tennessee River Boys were mostly still in their twenties, with big-time aspirations. They were opening shows for name acts and appearing every once in a while on TV. The group had more promise than the Western Room, even if the River Boys did have that “Opryland reputation.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e574"
    }
  }, [_vm._v("“There was a cheesy factor that I wasn’t entirely comfortable with,” Brian recalls. “But I saw something in the Tennessee River Boys that was different than any other band I’d been in: a combination of great talent, desire, commitment to each other, stability in a personal life—Dan was married, Marty was married, Jimmy was married.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e576"
    }
  }, [_vm._v("Jimmy’s membership came as a surprise to Brian. The two had met when Jimmy played in another Printers Alley club with a band called Sis, built around a pair of sisters from Washington State. Brian also knew Barbara Green, who was in the background when Jimmy opened the door at the audition. He "), _c('i', [_vm._v("didn’t ")]), _vm._v("know Barb was Jimmy’s wife. It was a bit awkward.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e581"
    }
  }, [_vm._v("“There was never anything between us,” Brian laughs, “but she was a barfly.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e583"
    }
  }, [_vm._v("Her attendance at the audition was only a temporary distraction. Brian quickly focused on the business at hand, set up his drum kit, and started playing with the Tennessee River Boys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e585"
    }
  }, [_vm._v("“There was, hands down, no doubt that Brian was the best drummer,” Marty remembers. “First of all, he’d listened to the tapes we’d sent him. Second of all, he really listened to us. He was, and [still is], the most musical drummer that I’ve ever played with. A lot of drummers, they just lay down a groove and you plug ’em in: "), _c('i', [_vm._v("I’m drivin’ a train, here we go, this is it. ")]), _vm._v("They play great stuff, but it’s like they’re kinda in their own little world and not payin’ attention to what everybody else is playing. Brian’s paying attention. If Jimmy hits a lick and it happens more than twice or whatever, he’ll inflect that on the drums. Vocal inflections—he ends up accentuating some of that stuff. I’ve always loved that about what he does, and he did that that day.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e590"
    }
  }, [_vm._v("“It didn’t even take one song,” Dan says. “Before [Brian] finished the song, I was like, "), _c('i', [_vm._v("This is the guy.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e595"
    }
  }, [_vm._v("Brian not only had a big drum sound, he also talked loud and had a quip or an observation for just about any direction the conversation went.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e598"
    }
  }, [_vm._v("“He definitely had that used-car-salesman vibe,” Dan chuckles, “but he was the drummer if we were gonna get the best.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e600"
    }
  }, [_vm._v("The Tennessee River Boys offered him the job that day, and Brian said yes before he left Danny’s house. He wasn’t entirely impressed with the band musically—“It was a little vanilla for my tastes,” he concedes—but he thought it had more potential than anything he was doing on Printers Alley.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e602"
    }
  }, [_vm._v("“They were young, good-looking guys,” he reasons, “and I still had a bit of a look goin’ for myself back then. And I had learned in my time in Nashville that music is a visually driven medium. At the end of the day, people hear with their eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e604"
    }
  }, [_vm._v("Brian left his drum set at Danny’s house, and the band practiced two or three times for several weeks before they set off in a van, pulling a trailer, for Brian’s first official gig in Pampa, Texas, during February 1986. It took at least fifteen hours each way, with a hotel stop in Oklahoma City. The gig paid all of $140—a lot of driving, a lot of time invested, relatively little pay.")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e606"
    }
  }, [_c('b', [_vm._v("LINEUP CHANGES")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e609"
    }
  }, [_vm._v("Saddled with such low compensation, the River Boys’ lineup continued to evolve. Steel player Mel Deal turned in his resignation. Instead of replacing him, they allowed the band to shrink from seven players to six, making what little money came in stretch a little further.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e611"
    }
  }, [_vm._v("Brian, as the newest face in the band, was unfettered by the River Boys’ history, and he was already beginning to wonder if the lineup was structured correctly. Danny and Matt might have been the founders, but he was more intrigued by Marty as a vocalist. Being the new guy, Brian kept his opinion to himself.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e613"
    }
  }, [_vm._v("“Danny had a way of warming up to a crowd that I just found fascinating,” Brian recalls. “He was the consummate showman, and maybe that was his strength versus his vocal capacity. He was good, don’t take me wrong, but through the course of the show, Danny would do most of the lead singin’, and Matt would do a couple of songs, and then Marty did a couple. And Marty did a song written by Dobie Gray, called ‘If I Ever Needed You, I Need You Now.’ It was a big, ’80s-power-ballad type thing, and gosh, I just couldn’t wait to get to that song to hear Marty Roe sing that song.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0035_001",
      "id": "d12e615",
      "src": "images/9781595552686_ePDFnf_0035_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e616"
    }
  }, [_c('b', [_vm._v("Fall of 1986. "), _c('i', [_vm._v("Left to right")]), _vm._v(": Jimmy Olander, Marty Roe, Brian Prout, Danny Gregg, Dan Truman, Matt Davenport")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e622"
    }
  }, [_vm._v("“I was like, "), _c('i', [_vm._v("Dad gum, this is the lead singer of this group. ")]), _vm._v("Danny was the personality, no doubt, and the only time Marty participated in communicating with the crowd was when the three of them were doing their little skits back and forth that came from Opryland.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e628"
    }
  }, [_vm._v("Because he kept that observation to himself, Brian was unaware that at least one of his fellow River Boys had briefl y considered that same idea.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e630"
    }
  }, [_vm._v("“I was in the front of our little converted bread truck [one time], and Marty was singing to himself as he was driving,” Jimmy says. “He had a character to his voice that sounded like a commercial country singer. He was actually more country than the other two guys. Matt Davenport had this smooth baritone. It was rich, Jim Reeves-ey, but no character. Marty’s got that little hick [flair]. There’s more air in the voice, and it had a little bit more character to it.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0036_002",
      "id": "d12e632",
      "src": "images/9781595552686_ePDFnf_0036_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e633"
    }
  }, [_c('b', [_vm._v("First tour bus. “Back then the Eagle was the bus to have . . . we called it the ‘Wounded Eagle.’ It broke down "), _c('i', [_vm._v("all ")]), _vm._v("the time! It was awful.” —Brian")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e639"
    }
  }, [_vm._v("Marty, however, also had self-esteem problems. Danny was Mr. Charisma, Matt had a rock-solid confidence, and Jimmy couldn’t picture Marty taking command from them on stage.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "1",
      "id": "d12e641",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e642"
    }
  }, [_vm._v("But self-esteem issues were the least of the troubles the band members were facing. Jimmy, who had originally joined the band for financial reasons, felt an even greater strain on his wallet—and his pride—after he and his wife wrecked two vehicles. He had pulled his restored 1953 GMC pickup into traffic in front of his house on Nashville’s Blair Boulevard and got hit by a Fiat. His wife, Barbara, had likewise slammed a car into a tree. Jimmy’s dad was now shelling out money to help them get back on their feet. The marriage had never really gelled. After about five years together, Jimmy and Barbara had had enough and divorced.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e644"
    }
  }, [_vm._v("Dan and Wendee couldn’t afford health insurance and had piled up a load of medical expenses. They owed doctors somewhere around fourteen thousand dollars—more than the couple was bringing home annually—and by the beginning of 1987, Wendee was pregnant again. She took their son, Ben, back to Utah to live with her parents until the delivery. And Dan hopscotched between several sets of friends who let him stay at their homes while he worked through their debt.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e646"
    }
  }, [_vm._v("“I kinda leeched off of people, [including] Marty and Robin,” Dan confesses. “No one ever charged me. So we were savin’ rent, [and] the utilities and the extras that come with that, and I would sock anything I made back into these medical bills. I got on a payment plan and doubled up on ’em, and paid it off in about three years.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e648"
    }
  }, [_vm._v("The Trumans’ separation was eased by one of the Tennessee River Boys’ few benefits. The group played periodic corporate events for Northwest Airlines, and part of the compensation came in free round-trip tickets. A Northwest gig emerged about every six or eight weeks, and each time, Dan would use his ticket to visit the family in Utah for a couple of weeks. Then it was back to Tennessee, where he’d stay at a friend’s house, rehearse, work, and wait for the next Northwest corporate booking.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e650"
    }
  }, [_vm._v("On the return trips, he’d bring preserves for Marty and Robin in lieu of rent money.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e653"
    }
  }, [_vm._v("“That was a big joke between Marty and I,” Dan says. “Wendee and her mom, they were always [canning] jams and jellies, so I would always bring a stash in my carry-on bag. So we always had two or three jars in their fridge. Robin was never—and still isn’t—much of a cook, and so every night, Marty and I were watching TV, eatin’ toast and jelly.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e655"
    }
  }, [_vm._v("Dan might have made do, but Danny Gregg could no longer hang. He was a little older than the rest of the band, had stowed away some cash when he cohosted the TNN show a few years before, but was tired of eating through his savings.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0038_001",
      "id": "d12e657",
      "src": "images/9781595552686_ePDFnf_0038_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e658"
    }
  }, [_c('b', [_vm._v("Tennessee River Boys promo picture 1987. "), _c('i', [_vm._v("Back")]), _vm._v(": Jimmy Olander, Danny Gregg, Dan Truman, Matt Davenport "), _c('i', [_vm._v("Front")]), _vm._v(": Marty Roe, Brian Prout")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e667"
    }
  }, [_vm._v("Touring, at least the way the Tennessee River Boys did it, was also harder on Danny than the rest of the crew. He had had a serious illness in his teens, and as a result he maintained an organic diet and went through extreme rituals to avoid germs in public places. Eating in fast-food joints and using gas-station restrooms didn’t suit him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e669"
    }
  }, [_vm._v("“Bein’ out on the road at that level, we didn’t have the extra coolness of a bus,” Dan says. “We were in a funky converted truck. We did a year of that. Even though it was clubs and shows with Mel McDaniel and Ronnie McDowell and those guys, he [Danny Gregg] was pretty much over it. He couldn’t take the intensity of that. I think if we had got a record deal—because it’s so different at the level we’re at now, you know, you have people cater to you and the bus and everything—he might have hung. But he just couldn’t handle that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e671"
    }
  }, [_vm._v("Danny’s departure was a major blow. He sang the bulk of the lead vocals and had a rapport with the audience that was irreplaceable. Even with Matt and Marty still on board, the band harbored doubts that it could survive the loss.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e673"
    }
  }, [_vm._v("“I was really disappointed ’cause he was a friend and a leader, and he had so much charisma,” Dan explains. “I remember we did this Elk’s Lodge down in Florida, Danny turned around to us and goes, ‘Plan B.’ And I remember the first time I heard that, turning around to the drummer: ‘Plan B?’ He goes, ‘Crowd agitation.’ If the response wasn’t great, he’d turn to crowd agitation. Danny could do it big-time. He was like Don Rickles in this strawberry-blond smile. He would start [jabbing at] people in the audience. It was hilarious.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e675"
    }
  }, [_vm._v("As they’d done when Mel Deal quit, the Tennessee River Boys initially tried to get by with one less musician. Matt assumed the lead vocal position, with Marty taking a small share of the songs and providing the high harmony. They needed another voice for the baritone parts, and they tried all three remaining players—Jimmy, Dan, and Brian—deciding Brian should take a Don Henley role and sing from the drum kit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e677"
    }
  }, [_vm._v("That lasted only a few shows before they agreed they indeed needed to replace Danny. Matt would remain the front man, and they’d find a multi-instrumentalist to sing baritone.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e679"
    }
  }, [_c('i', [_vm._v("Gene Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e683"
    }
  }, [_vm._v("The River Boys auditioned a number of musicians. But one who stood out was a referral Jimmy got through stand-up bass player Mark Schatz.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e685"
    }
  }, [_vm._v("“I’ve got this friend of mine,” Mark told Jimmy, “really good musician, really good singer. He’s mostly doin’ cabinet work and doing woodworking, and it’s a crying shame. He needs to be playing [regularly]. I don’t know if he would be into this or not. His name’s Gene Johnson.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e687"
    }
  }, [_vm._v("Jimmy’s ears perked up. As a kid in Michigan, he’d persuaded his father to take him to a club called the Raven Gallery to see Eddie Adcock’s bluegrass band, IInd Generation, which featured a mandolin player named Gene Johnson. Was this the same guy?")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0040_001",
      "id": "d12e689",
      "src": "images/9781595552686_ePDFnf_0040_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e690"
    }
  }, [_c('b', [_vm._v("Tennessee River Boys, 1987. "), _c('i', [_vm._v("Left to right")]), _vm._v(": Marty Roe, Gene Johnson, Matt Davenport, Brian Prout, Dan Truman, Jimmy Olander.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e696"
    }
  }, [_vm._v("“Gene played really smooth, really intelligent mandolin,” Jimmy says. “It wasn’t Bill Monroe, I’m-crankin’-away-on-two-strings, rural, lonesome stuff. It was technically really well done. And I had his records.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e698"
    }
  }, [_vm._v("Gene was out of town when Jimmy placed the call, so Jimmy chatted a bit with June Johnson, who took down the number with a note for her husband to call about an audition with the Tennessee River Boys.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e700"
    }
  }, [_vm._v("Gene ignored the message. He’d moved to Nashville twenty months before in an attempt to get out of bluegrass and get into country, which promised a better income. He’d played with some significant bluegrass musicians—including Eddie Adcock and J. D. Crowe. He’d never heard of the Tennessee River Boys, but with that name, the group had to be bluegrass. If he was going to bite the bullet and go back to that world, he’d do it with an act people knew.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0041_001",
      "id": "d12e702",
      "src": "images/9781595552686_ePDFnf_0041_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e703"
    }
  }, [_c('b', [_vm._v("II Generation at a bluegrass festival in 1973. "), _c('i', [_vm._v("Left to right")]), _vm._v(": Jeff Wisor, Gene Johnson, Eddie Adcock.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e709"
    }
  }, [_vm._v("Jimmy called again. He made it clear that he was a fan and insisted the River Boys were a country band. He told Gene about the Opryland history—not a strong sales point—but Gene auditioned anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e712"
    }
  }, [_vm._v("“I’d been there and seen some of the shows at the park,” Gene says, “and they all had a certain typical staged imitation thing usually goin’ on. I almost cringed a little bit when he said that, but the fact that they were off and starting to play on the road, I thought, "), _c('i', [_vm._v("Well, let’s go up and sit in and see what it sounds like.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e717"
    }
  }, [_vm._v("The audition was set at the home of the drummer, Brian, who had recently married another drummer, Nancy Given, who was part of Wild Rose, an all-female band. Jimmy, who’d so admired Gene as a kid, found it surreal to suddenly audition one of his heroes. The rest of the River Boys were unfamiliar with Gene. They’d been told about his history, but since they had no bluegrass background, his resume meant little to them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e719"
    }
  }, [_vm._v("In the middle of the audition, Pam Gadd—the lead vocalist for Wild Rose—wandered into the living room and asked for Gene’s autograph. That was just weird—people who are significant enough to sign autographs aren’t usually required to audition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e721"
    }
  }, [_vm._v("“I remember the look on Marty and Matt’s faces,” Gene laughs, “kinda goin’, "), _c('i', [_vm._v("Who is this guy?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e726"
    }
  }, [_vm._v("The better question was what to do with him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e728"
    }
  }, [_vm._v("“We weren’t looking for a mandolin player, and we weren’t looking for a tenor,” Marty says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e730"
    }
  }, [_vm._v("Gene wasn’t looking to sing baritone either. And when one of the River Boys said the singers in the group had always traded off the lead vocals and tenor parts—well, Gene certainly wasn’t looking for that.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0042_001",
      "id": "d12e732",
      "src": "images/9781595552686_ePDFnf_0042_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e733"
    }
  }, [_c('b', [_vm._v("Brian’s former home on McGavock Pike. “We rehearsed in the basement and in the winter months we would disconnect the hose from the dryer and use that to heat the room.” —Brian")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e736"
    }
  }, [_vm._v("“I come from the bluegrass field where one thing you knew for sure is you tried to keep your harmonies the same,” he explains. “If you’ve got somebody that’s got a good tenor voice, you have him sing tenor. It gives you a sound, something that’s different from somebody else. You definitely don’t wanna just keep switchin’ all the harmonies. I think that was just having come out of the park, they weren’t thinking on a professional level with everything yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e738"
    }
  }, [_vm._v(" Gene did see some other qualities when they played together, though, and that was enough for him to give them a tentative thumbs-up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e741"
    }
  }, [_vm._v("“I was very impressed with Jimmy and very impressed with Dan, impressed with Brian,” Gene reflects. “Matt seemed to be a fine bass player, you know. Marty couldn’t play rhythm very well, but he sang well, so my first impression of ’em was, "), _c('i', [_vm._v("Well, pretty talented bunch of guys.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e745"
    }
  }, [_vm._v("“So I thought, "), _c('i', [_vm._v("I’ll play some with ’em. I don’t have anything else pressing. It’s in my best interest to pick up a few dollars here, if I ")]), _vm._v("can "), _c('i', [_vm._v("pick up a few dollars, and we’ll see how things work out.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e753"
    }
  }, [_vm._v("From the River Boys’ perspective, Gene might have been a Rolling Stones–type solution: you can’t always get what you want. They did get what they needed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e755"
    }
  }, [_vm._v("“Even though I thought it was the end of the world when we lost Danny Gregg,” Dan says, “Gene was a part of the puzzle that was missing. That harmony made all the difference in the world for us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e757"
    }
  }, [_vm._v("Their new mandolin player made his debut with the Tennessee River Boys during a test run in Clewiston, Florida, on May 4, 1987. The next day they played Jekyll Island, Georgia, and tossed him three hundred dollars for his efforts. They also made Gene a full-time member, commencing with a three-week stint at the Landmark Hotel in Las Vegas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e759"
    }
  }, [_vm._v("His addition created some apprehension for Marty. Matt, one of the original members, was now the official lead singer. Marty had been bumped from the easily distinguished high-tenor harmonies to the lower voice in the triad. He had the second longest tenure in the Tennessee River Boys, yet his place in the creative pecking order—from the outside, anyway—had dropped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e761"
    }
  }, [_vm._v("“I was somewhat resistant,” Marty admits, “’cause I loved singin’ that high-harmony part, you know. I got to sing lead on one or two songs, but I [had been] mostly singin’ high harmony and playin’ acoustic. I really didn’t have a huge role in the band, to be honest. I was actually honored to be playin’ with them. All of these guys are better musicians than I am, so I was just kind of tryin’ to hang on to my job—what little job I had.”")]), _vm._v(" "), _c('p', {
    staticClass: "h2",
    attrs: {
      "id": "d12e763"
    }
  }, [_c('b', [_vm._v("WHO IS IN CHARGE?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e766"
    }
  }, [_vm._v("Things seemed to be stabilizing in the band, even if the guys continued to struggle financially. Gene, who was thirty-seven, had been married to June for fourteen years, and they had two children. Brian and Marty were each married. Jimmy reveled in life after his divorce. And Wendee delivered the Trumans’ second son, Chad, in September 1987 and moved back to Tennessee.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0044_001",
      "id": "d12e768",
      "src": "images/9781595552686_ePDFnf_0044_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e769"
    }
  }, [_c('b', [_vm._v("Chad (1 year), Dan, Ben (4 years)")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e773"
    }
  }, [_vm._v("Most of the guys found outside sources for additional income. Gene continued his carpentry, Jimmy and Marty mowed lawns, and Brian drove tourists around in a bus to see the homes of the stars.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e775"
    }
  }, [_vm._v("Despite the stability, however, the River Boys developed some tension over ownership. Matt and Marty, as the senior members, served as leaders, and since Marty invariably deferred to his partner, that left Matt in charge. As they continued to contemplate a recording deal, the guys began debating what percentage of the group each member owned. Matt insisted his and Marty’s tenure entitled them to a larger share of any income. The rest of the band thought the income should be split evenly. And Marty was siding with them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e777"
    }
  }, [_vm._v("“It’s like Matt and I are owners of nothing if these guys don’t stay,” Marty shrugs. “So it was just the right thing to do. I was glad to do it, and it made perfect sense. We were basically a six-way partnership anyhow; we just needed to make it that way officially.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0045_001",
      "id": "d12e779",
      "src": "images/9781595552686_ePDFnf_0045_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e780"
    }
  }, [_c('b', [_vm._v("The Tennesee River Boys before Dana Williams joined the band, 1987. "), _c('i', [_vm._v("Left to right")]), _vm._v(": Matt Davenport, Brian, Marty, Dan, Gene, Jimmy.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e786"
    }
  }, [_c('i', [_vm._v("Keith Stegall’s Contribution")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e789"
    }
  }, [_vm._v("The partnership would change even more when they caught the attention of singer-songwriter Keith Stegall in 1988. After writing jazz singer Al Jarreau’s lone Top 10 pop hit “We’re in This Love Together” in 1981, Keith had secured three Top 20 singles as a country artist in the mid-’80s. He’d also written several other songs that had received huge radio play, including Glen Campbell’s “A Lady Like You” and Mickey Gilley’s “Lonely Nights.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e791"
    }
  }, [_vm._v("Keith was looking to become a producer and was working with a shy, lanky singer-songwriter named Alan Jackson. Keith also had worked out a deal with his publishing company in which he could produce some material on the Tennessee River Boys and get demos made for some of his songs at the same time. So he took them into the studio to see what they could develop.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e793"
    }
  }, [_vm._v("Matt’s position as the lead singer and bass player posed a technical problem. His voice and his instrument needed to be on separate tracks; if he recorded both simultaneously, Keith would never be able to untangle them in the control room. The solution was easy: Marty would sing “scratch” vocals while Matt laid down the bass part at the same time the other musicians recorded their tracks. They could go in later and replace Marty’s voice with Matt’s.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e795"
    }
  }, [_vm._v("Working with those tracks, Keith heard Marty delivering the songs that Matt normally sang with a different edge. After the band went home one night, Keith called several members to float an idea. He was convinced that if the River Boys were going to make it commercially, they needed Marty in the lead slot.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e797"
    }
  }, [_vm._v("It wasn’t the first time anyone had thought about giving Marty the chance to lead. Brian had reached that conclusion soon after joining. Jimmy thought Marty had the chops for the job, but not necessarily the bravado. Gene, the newcomer, had already recognized that Marty had more character as a vocalist. And Dan had long felt Marty was a more powerful, more expressive singer. Yet no one had ever discussed it. Matt was a likable guy, certainly capable as a singer, and he had a much bigger personality than Marty. He’d kind of risen to lead the pack, and no one had thought to challenge the status quo.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e800"
    }
  }, [_vm._v("“Matt is such a great songwriter, and he’s such a great showman,” Dan says. “To me, there was still that perception that he was the guy that hired me.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e802"
    }
  }, [_vm._v("Keith talked it over with the guys in a band meeting, and Matt reluctantly accepted what certainly felt like a demotion. They made the demos and shopped them around town again, and the guys had such a positive feeling about their potential that Jimmy—struggling though he was—turned down a lucrative gig.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e804"
    }
  }, [_vm._v("Lee Greenwood, who’d slipped “God Bless the U.S.A.” into a string of nineteen Top 10 hits since 1981, offered him a job as the guitarist in his road band. Jimmy told Lee he was optimistic the River Boys could land a deal and that if they did, he wouldn’t be able to finish the tour. Lee thanked him for his honesty and moved on.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e806"
    }
  }, [_c('i', [_vm._v("Shopping Around and Hangin’ On")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e809"
    }
  }, [_vm._v("Keith took the River Boys demo around town, and the feedback was better than when Snuffy Miller had tried several years earlier. Jim Ed Norman, still at Warner Bros., was particularly impressed with the progress they’d made but didn’t have room for them on his roster.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e811"
    }
  }, [_vm._v("So the guys continued their outside jobs. One day, Brian was giving yet another bus tour of the homes of the stars and encountered an ironic sight: just weeks after Jimmy had passed on the road job, he was out cutting grass for the man he’d turned down, Lee Greenwood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e813"
    }
  }, [_vm._v("At the end of ’88, the River Boys had a two-week engagement at Le Louisiane in Quebec, the perfect opportunity for Marty and Matt to adjust to their new roles. Matt still introduced some of the songs and sang lead a bit, but they had literally swapped positions.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e815"
    }
  }, [_vm._v("“I was a nervous wreck,” Marty says. “I hadn’t really given a whole lot of thought about being put in that [front man] position, so it was a little overwhelming for me. But we made it through that, and everybody seemed to think it went well and that was the path.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e817"
    }
  }, [_vm._v("But maybe not the path for everyone. Matt had children to feed, and his wife was unhappy that he was chasing this music dream instead of working a more standard job. He had envisioned being a 50 percent owner of a band in which he sang lead. Now he had one-sixth partnership in a group where he sang the low harmonies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e819"
    }
  }, [_vm._v("“I’m home maybe a day or two, and Matt calls me,” Marty recalls. “It’s the end of the year, we don’t have any work, probably through January or whatever. Matt told me—and this is a quote—that ‘the Lord is leading me to leave the band.’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e821"
    }
  }, [_vm._v("Matt was gone.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e824"
    }
  }, [_vm._v("While the calendar was full of holes, the River Boys had one attractive date on the books: a January 23 appearance on Ralph Emery’s TNN talk show "), _c('i', [_vm._v("Nashville Now")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e829"
    }
  }, [_vm._v("They needed a replacement, and they needed him quick. And this time they couldn’t be flexible the way they had been when Gene came on board: the new guy needed to sing the third harmony part and play bass.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e831"
    }
  }, [_vm._v("They flirted with Alan LaBeouf, who had just left Baillie & the Boys, a group that had gone Top 10 with the radio-friendly “Oh Heart” and “Long Shot.” Alan, who had played Paul McCartney in a Broadway production of "), _c('i', [_vm._v("Beatlemania")]), _vm._v(", was initially interested but canceled his audition when his plate filled up. He ultimately returned to work in Beatles tribute shows.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e836"
    }
  }, [_vm._v("Gene also approached Jeff Amiot, who’d played bass in a couple of his earlier bluegrass groups. Jeff was working at a hospital in New York State and valued having a reliable paycheck. He declined the offer too.")]), _vm._v(" "), _c('p', {
    staticClass: "h3l",
    attrs: {
      "id": "d12e838"
    }
  }, [_c('i', [_vm._v("Dana Williams")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e841"
    }
  }, [_vm._v("Jimmy put in a call to Dana Williams, the former Jimmy C. Newman sideman who used to watch the original version of the River Boys when Ty Herndon—not Marty—sang most of the lead parts. When Jimmy did his first Opryland stint as a member of the "), _c('i', [_vm._v("Country Music USA ")]), _vm._v("cast, he had become acquainted with Dana, and they’d periodically run into each other on the Nashville club circuit.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e846"
    }
  }, [_vm._v("Jimmy was rather sheepish during the call, still feeling some embarrassment about working with a band best known for its theme-park connection. But he asked Dana to audition anyway.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e848"
    }
  }, [_vm._v("“I thought it was gonna be way beneath him,” Jimmy says. “But he’s like, ‘Dude, I "), _c('i', [_vm._v("love ")]), _vm._v("the Tennessee River Boys! I used to see ’em all the time out there at the park. I love them. When you want me to come?’”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e853"
    }
  }, [_vm._v("They ended up talking for a couple of hours that day, and Dana found himself making excuses when he told his wife, Lisa, he had an audition. After a weary decade of playing nightclubs and backing up Grand Ole Opry performers, he had brought home an application to attend electronics school.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e855"
    }
  }, [_vm._v("She didn’t need to worry, he promised. He was done with this music thing. Jimmy was an old friend and auditions never lead anywhere. (“If you get ‘auditioned,’ that’s the first breath of death for that gig,” Dana still maintains.)")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e857"
    }
  }, [_vm._v("“I’m not gonna get sucked in now,” Dana told her.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e860"
    }
  }, [_vm._v("Still, there was something different about this band.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e862"
    }
  }, [_vm._v("“I had been looking from all of my experience [for] someone I could go on the road with that nobody’s doin’ drugs, nobody drinks, and there wasn’t any issue like that,” Dana says. “And when I get this call from Jimmy, I remember tellin’ my wife at the time, ‘I don’t know "), _c('i', [_vm._v("why ")]), _vm._v("I feel I need to do this, but I just feel like I need to go and do this and see what happens. I don’t have a clue why. They don’t have one thing to offer anybody. I will say it would be kinda cool to do that TV show.’ And that was the main reason—they had this TV show and, yeah, it’d kinda be cool to be on that.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e867"
    }
  }, [_vm._v("The audition in Brian’s garage was less than comfortable. It was the dead of winter, so they turned on the clothes dryer and left the door open to heat the room. Just one lightbulb hung from the ceiling, and they positioned Dana under it “interrogation style,” as Marty says.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e869"
    }
  }, [_vm._v("“The package that showed up to audition was the old Dana Williams that was heavy [with a] really, really full, bushy beard,” Jimmy says, “this big, unkept [guy] with the Johnny Lee hat and the calico shirt. It was that guy showin’ up for the Tennessee River Boys, [who had been] pretty boys out at Opryland doing a six-piece thing where everybody had to look stylish somewhat.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e871"
    }
  }, [_vm._v("Jimmy didn’t know how his old friend would go over. But they’d already heard plenty of bad auditions. They had tried out a wannabe from Belmont College on a peaceful, easy mid-tempo number, and the kid started thumping the strings like a heavy-metal bassist. That clearly wouldn’t work. Other guys could play the bass parts but were shaky on the vocals.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e873"
    }
  }, [_vm._v("Dana had a bit of an attitude about auditioning, but when it came time to do the job, he sailed through the music—especially on the vocals. Dana had learned harmony through his relationship with his uncles, the Osborne Brothers, best known for the bluegrass classic “Rocky Top.” His vocal approach fit perfectly with Gene’s bluegrass background, and both of them meshed well with Marty’s twang.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e875"
    }
  }, [_vm._v("“I gotta say, man, there was kind of an instant thing,” Dana reflects. “You could hear it. It just instantly—"), _c('i', [_vm._v("shoomp")]), _vm._v("—came together.”")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0050_004",
      "id": "d12e880",
      "src": "images/9781595552686_ePDFnf_0050_004.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e881"
    }
  }, [_c('b', [_vm._v("October 19, 1991, Paducah, Kentucky. "), _c('i', [_vm._v("L to r")]), _vm._v(": Gene, Dana, Marty. “So much hair, so little space.” —Jimmy")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e887"
    }
  }, [_vm._v("Because of Dana’s attitude and his presentation, they hesitated. There was another guy who tried out who was almost as good, and he had a lot less of an attitude. They decided to bring both players back for a second audition.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e889"
    }
  }, [_vm._v("Dana groused about that, too, but he came back. And in addition to running through songs they’d asked him to learn, they tested him on a few they hadn’t assigned him. He fell into the right harmonies automatically.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e892"
    }
  }, [_vm._v("“He wouldn’t even know these songs—and, to this day, he still doesn’t,” Jimmy laughs. “Even now, there’s songs that we do where he won’t sing all the consonants, but he gets the vowels right and he blends. Marty accuses him of this: ‘You don’t even know the words!’ But it still sounds good.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e894"
    }
  }, [_vm._v("Dana was hired. Within short order, he’d join them on "), _c('i', [_vm._v("Nashville Now")]), _vm._v(". And they hoped he’d stay as they plowed forward with their pursuit of a recording contract. Time, it seemed, was running out. Wendee Truman had grown tired of feeding a family of four on twelve thousand dollars a year. Dan had promised he’d give it just one more year. Marty had determined—much like Alabama’s Randy Owen had done a decade before—that he would quit if he hadn’t made it by age thirty. That deadline was twenty months away.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0051_002",
      "id": "d12e899",
      "src": "images/9781595552686_ePDFnf_0051_002.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e900"
    }
  }, [_c('b', [_vm._v("Dollywood at Pigeon Forge. "), _c('i', [_vm._v("Left to right")]), _vm._v(": Dan, Jimmy, Dana, Brian, Marty, Gene")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e906"
    }
  }, [_vm._v("They were long gone from the theme park. The Tennessee River Boys were uncertain how much longer they could continue the ride. But they would take it together. The six musicians had come from five different states and very different backgrounds, but they shared a common bond. They each wanted to be part of a successful "), _c('i', [_vm._v("band")]), _vm._v("—an aspiration that cut against the grain in country music.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e911"
    }
  }, [_vm._v("Solo artists can make decisions—about songs, about tours, about managers—in a snap. A band has an extra layer of friction: it requires extra meetings, lots of communication, and an uncommon willingness to sacrifice personal goals for the good of the team.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0052_001",
      "id": "d12e913",
      "src": "images/9781595552686_ePDFnf_0052_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e914"
    }
  }, [_c('b', [_c('i', [_vm._v("Left to right")]), _vm._v(": Dan, Gene, Dana, Marty, Jimmy, and Brian, singing the National Anthem at the Braves game, July 1995. “There’s nothing like acid washed jeans and big hair to prove we were fashion forward in the early 90’s . . . "), _c('i', [_vm._v("not")]), _vm._v("!” —Jimmy")])]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "9781595552686_ePDFnf_0052_003",
      "id": "d12e922",
      "src": "images/9781595552686_ePDFnf_0052_003.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d12e923"
    }
  }, [_c('b', [_vm._v("July 1995. “Atlanta Braves vs. Pittsburg Pirates . . . this was the year the Braves ended up going to the World Series.” —Brian")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d12e926"
    }
  }, [_vm._v("Finding "), _c('i', [_vm._v("six ")]), _vm._v("guys with those personal skills? That’s a feat. Each of the River Boys had that kind of dedication, though they came to it in different ways.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83e3e4f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rola_1595552685_epub_c9_r1.vue
// module id = 78
// module chunks = 0